"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addOpenAppCategory = addOpenAppCategory;
exports.addTemplate = addTemplate;
exports.applyOpenAppLocationInterface = applyOpenAppLocationInterface;
exports.applyOpenAppOrderPath = applyOpenAppOrderPath;
exports.bindOpenAppTester = bindOpenAppTester;
exports.createOpenAppAppeal = createOpenAppAppeal;
exports.deleteOpenAppCategory = deleteOpenAppCategory;
exports.deleteOpenAppQrcodeRule = deleteOpenAppQrcodeRule;
exports.deleteTemplate = deleteTemplate;
exports.getAuthorizationSession = getAuthorizationSession;
exports.getAuthorizerAppDetail = getAuthorizerAppDetail;
exports.getAuthorizerAppList = getAuthorizerAppList;
exports.getCallbackLogList = getCallbackLogList;
exports.getOpenAppAppealRecords = getOpenAppAppealRecords;
exports.getOpenAppBasicInfo = getOpenAppBasicInfo;
exports.getOpenAppCategoryConfig = getOpenAppCategoryConfig;
exports.getOpenAppDomainConfig = getOpenAppDomainConfig;
exports.getOpenAppIllegalRecords = getOpenAppIllegalRecords;
exports.getOpenAppLocationInterfaces = getOpenAppLocationInterfaces;
exports.getOpenAppMemberConfig = getOpenAppMemberConfig;
exports.getOpenAppPrivacyConfig = getOpenAppPrivacyConfig;
exports.getOpenAppQrcodeRuleConfig = getOpenAppQrcodeRuleConfig;
exports.getOpenAppReleasePrecheck = getOpenAppReleasePrecheck;
exports.getPlatformList = getPlatformList;
exports.getTemplateDraftList = getTemplateDraftList;
exports.getTemplateList = getTemplateList;
exports.modifyOpenAppCategory = modifyOpenAppCategory;
exports.publishOpenAppQrcodeRule = publishOpenAppQrcodeRule;
exports.saveOpenAppBasicHeadImage = saveOpenAppBasicHeadImage;
exports.saveOpenAppBasicSignature = saveOpenAppBasicSignature;
exports.saveOpenAppPrivacyConfig = saveOpenAppPrivacyConfig;
exports.saveOpenAppQrcodeRule = saveOpenAppQrcodeRule;
exports.saveOpenAppServerDomains = saveOpenAppServerDomains;
exports.saveOpenAppWebViewDomains = saveOpenAppWebViewDomains;
exports.savePlatform = savePlatform;
exports.startAuthorization = startAuthorization;
exports.startTicketPush = startTicketPush;
exports.syncAuthorizerAppDetail = syncAuthorizerAppDetail;
exports.unbindOpenAppTester = unbindOpenAppTester;
exports.uploadOpenAppAppealMedia = uploadOpenAppAppealMedia;
exports.uploadOpenAppCategoryCertificate = uploadOpenAppCategoryCertificate;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function getPlatformList() {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/platform/list',
    method: 'get'
  });
}
function savePlatform(data) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/platform',
    method: 'post',
    data: data
  });
}
function startTicketPush(platformId) {
  return (0, _request.default)({
    url: "/admin/wechat-open-platform/platform/".concat(platformId, "/ticket/start"),
    method: 'post'
  });
}
function getAuthorizerAppList(params) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/list',
    method: 'get',
    params: params
  });
}
function getAuthorizerAppDetail(platformId, companyAppId) {
  return (0, _request.default)({
    url: "/admin/wechat-open-platform/app/".concat(companyAppId, "/detail"),
    method: 'get',
    params: {
      platformId: platformId
    }
  });
}
function syncAuthorizerAppDetail(platformId, companyAppId) {
  return (0, _request.default)({
    url: "/admin/wechat-open-platform/app/".concat(companyAppId, "/sync"),
    method: 'post',
    params: {
      platformId: platformId
    }
  });
}
function getOpenAppBasicInfo(params) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/basic_info',
    method: 'get',
    params: params
  });
}
function saveOpenAppBasicSignature(data) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/basic_signature_save',
    method: 'post',
    data: data
  });
}
function saveOpenAppBasicHeadImage(data) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/basic_head_image_save',
    method: 'post',
    data: data
  });
}
function applyOpenAppOrderPath(data) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/order_path_apply',
    method: 'post',
    data: data
  });
}
function getOpenAppMemberConfig(params) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/member_config',
    method: 'get',
    params: params
  });
}
function bindOpenAppTester(data) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/tester_bind',
    method: 'post',
    data: data
  });
}
function unbindOpenAppTester(data) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/tester_unbind',
    method: 'post',
    data: data
  });
}
function getOpenAppDomainConfig(params) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/domain_config',
    method: 'get',
    params: params
  });
}
function saveOpenAppServerDomains(data) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/server_domain_save',
    method: 'post',
    data: data
  });
}
function saveOpenAppWebViewDomains(data) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/webview_domain_save',
    method: 'post',
    data: data
  });
}
function getOpenAppCategoryConfig(params) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/category_config',
    method: 'get',
    params: params
  });
}
function addOpenAppCategory(data) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/category_add',
    method: 'post',
    data: data
  });
}
function modifyOpenAppCategory(data) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/category_modify',
    method: 'post',
    data: data
  });
}
function deleteOpenAppCategory(data) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/category_delete',
    method: 'post',
    data: data
  });
}
function uploadOpenAppCategoryCertificate(data) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/category_certificate_upload',
    method: 'post',
    data: data
  });
}
function getOpenAppPrivacyConfig(params) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/privacy_config',
    method: 'get',
    params: params
  });
}
function saveOpenAppPrivacyConfig(data) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/privacy_save',
    method: 'post',
    data: data
  });
}
function getOpenAppReleasePrecheck(params) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/release_precheck',
    method: 'get',
    params: params
  });
}
function getOpenAppQrcodeRuleConfig(params) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/qrcode_rule_config',
    method: 'get',
    params: params
  });
}
function saveOpenAppQrcodeRule(data) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/qrcode_rule_save',
    method: 'post',
    data: data
  });
}
function publishOpenAppQrcodeRule(data) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/qrcode_rule_publish',
    method: 'post',
    data: data
  });
}
function deleteOpenAppQrcodeRule(data) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/qrcode_rule_delete',
    method: 'post',
    data: data
  });
}
function getOpenAppLocationInterfaces(params) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/location_interface_list',
    method: 'get',
    params: params
  });
}
function applyOpenAppLocationInterface(data) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/location_interface_apply',
    method: 'post',
    data: data
  });
}
function getOpenAppIllegalRecords(params) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/illegal_record_list',
    method: 'get',
    params: params
  });
}
function getOpenAppAppealRecords(params) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/appeal_record_list',
    method: 'get',
    params: params
  });
}
function createOpenAppAppeal(data) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/appeal_create',
    method: 'post',
    data: data
  });
}
function uploadOpenAppAppealMedia(data) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/app/appeal_media_upload',
    method: 'post',
    data: data
  });
}
function getTemplateDraftList(platformId) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/template/draft/list',
    method: 'get',
    params: {
      platformId: platformId
    }
  });
}
function getTemplateList(platformId) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/template/list',
    method: 'get',
    params: {
      platformId: platformId
    }
  });
}
function addTemplate(data) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/template',
    method: 'post',
    data: data
  });
}
function deleteTemplate(platformId, templateId) {
  return (0, _request.default)({
    url: "/admin/wechat-open-platform/template/".concat(templateId),
    method: 'delete',
    params: {
      platformId: platformId
    }
  });
}
function startAuthorization(data) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/authorization/start',
    method: 'post',
    data: data
  });
}
function getAuthorizationSession(sessionId) {
  return (0, _request.default)({
    url: "/admin/wechat-open-platform/authorization/session/".concat(sessionId),
    method: 'get'
  });
}
function getCallbackLogList(params) {
  return (0, _request.default)({
    url: '/admin/wechat-open-platform/callback/log/list',
    method: 'get',
    params: params
  });
}